import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';

const SHOULD_DEBOUNCE_TYPES = [
    'textarea',
    'textfield',
    'contactEmail',
    'contactPhone',
    'currencyfield',
    'numberfield',
    'yearfield',
    'cprfield',
    'emailfield',
    'phonefield',
    'groupOfTextFields',
    'cvrfield'
];
export const shouldDebounceSave = (formConfig: FormConfig | undefined, key: string): boolean => {
    if (!formConfig) return false;

    const allElements = formConfig.pages.flatMap((page) => page.elements ?? []);
    const targetElement = allElements.find((el) => el.elementId === key);
    return targetElement ? SHOULD_DEBOUNCE_TYPES.includes(targetElement.type) : false;
};
